var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3086 41.1427C30.4519 41.1484 30.5872 41.2099 30.6857 41.3142C30.7162 41.3785 30.732 41.4487 30.732 41.5199C30.732 41.591 30.7162 41.6613 30.6857 41.7256C30.7403 43.5442 30.0702 45.31 28.8228 46.6346C27.5754 47.9591 25.8529 48.7339 24.0343 48.7885C22.2157 48.843 20.4499 48.1729 19.1253 46.9255C17.8008 45.6781 17.026 43.9557 16.9714 42.137C16.9492 42.0146 16.9562 41.8887 16.992 41.7695C17.0278 41.6503 17.0912 41.5413 17.1772 41.4513C17.2793 41.3183 17.4182 41.2182 17.5766 41.1634C17.735 41.1085 17.9061 41.1013 18.0686 41.1427H30.3086Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 34.2857C48 33.8311 47.8194 33.395 47.4979 33.0735C47.1764 32.752 46.7404 32.5714 46.2857 32.5714C44.2629 32.5714 40.4229 29.1429 40.4229 16.4229C40.4229 12.0672 38.6926 7.89003 35.6127 4.81014C32.5328 1.73026 28.3556 0 24 0C19.6444 0 15.4672 1.73026 12.3873 4.81014C9.3074 7.89003 7.57714 12.0672 7.57714 16.4229C7.57714 29.1771 3.73714 32.5714 1.71429 32.5714C1.25963 32.5714 0.823594 32.752 0.502103 33.0735C0.180612 33.395 0 33.8311 0 34.2857C0 34.7404 0.180612 35.1764 0.502103 35.4979C0.823594 35.8194 1.25963 36 1.71429 36H46.2857C46.7404 36 47.1764 35.8194 47.4979 35.4979C47.8194 35.1764 48 34.7404 48 34.2857Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.48172796abde609a56fd5a911bef4836.svg";
export { ForwardRef as ReactComponent };